import { render, staticRenderFns } from "./ForgotPasswordComponent.vue?vue&type=template&id=ba6728ea&"
import script from "./ForgotPasswordComponent.vue?vue&type=script&lang=js&"
export * from "./ForgotPasswordComponent.vue?vue&type=script&lang=js&"
import style0 from "./ForgotPasswordComponent.vue?vue&type=style&index=0&id=ba6728ea&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports